<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'integrasi-outlet'" :bg-grey="true" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Integrasi Outlet" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-x-20" v-if="formReady">
                    <div class="m-d-16 h-perangkat d-grid-12">
                        <div class="grid-cspan-2 a-self-center j-self-center">
                            <img
                                v-if="getOutlet && getOutlet.logo_url"
                                :src="imgBucketSrc + getOutlet.logo_url"
                                class="grid-rspan-2 grid-cspan-1"
                                width="58"
                                height="58"
                            />
                            <img
                                v-else
                                src="@/assets/gambar/Rectangle43.svg"
                                class="grid-rspan-2 grid-cspan-1"
                                width="58"
                                height="58"
                            />
                        </div>
                        <div class="grid-cspan-10 p-l-8">
                            <p class="m-d-0 f-16 f-semi f-c-black">{{ getOutlet.nama }}</p>
                            <p
                                v-if="device.nomor"
                                class="m-d-0 f-14 f-regular f-c-midgrey"
                                style="border: 1px solid #EDEDED; box-sizing: border-box; border-radius: 4px; width: fit-content; padding: 2px 4px;"
                            >
                                <IconBased width="14" height="14">
                                    <template v-slot:icons>
                                        <WhatsappIconMini clr-fill="#6F7287" />
                                    </template>
                                </IconBased>
                                +{{ getCC }}{{ device.nomor }}
                            </p>
                            <p class="m-d-0 f-14 f-regular f-c-midgrey" v-if="device.nomor">({{ device.nama }})</p>
                            <p class="m-d-0 f-14 f-semi f-c-blue" @click="changeDevice">Pindah ke perangkat lain</p>
                        </div>
                    </div>
                    <div class="nota-transaksi m-t-16 m-d-16">
                        <div><label class="m-d-0 f-c-midgrey f-16 f-regular">Nota transaksi</label></div>
                        <ItemSettingWA jenis-setting="transaksi-reg" :is-show-draft="useTemplate('transaksi')">
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen setelah melakukan transaksi reguler atau deposit.
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
                                        :checkboxes="getSettingWhatsapp('transaksi-reg')"
                                        @selected="toogleOnOff($event, 'transaksi')"
                                        :checked="isSet.transaksi"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.transaksi)"></div>
                                </div>
                            </template>
                        </ItemSettingWA>
                        <!-- <ItemSettingWA
                            jenis-setting="transaksi-snap"
                            :is-show-draft="useTemplate('snap_transaksi_nota')"
                        >
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen setelah melakukan transaksi Self Service atau Drop Off
                                        (Snapbridge).
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
                                        :checkboxes="getSettingWhatsapp('transaksi-snap')"
                                        @selected="toogleOnOff($event, 'snap_transaksi_nota')"
                                        :checked="isSet.snap_transaksi_nota"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.snap_transaksi_nota)"></div>
                                </div>
                            </template>
                        </ItemSettingWA> -->
                    </div>
                    <div class="nota-transaksi m-t-16 m-d-16">
                        <div><label class="m-d-0 f-c-midgrey f-16 f-regular">Nota Top Up</label></div>
                        <ItemSettingWA jenis-setting="top-up-deposit" :is-show-draft="useTemplate('beli_deposit')">
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen setelah melakukan Top Up Deposit.
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
                                        :checkboxes="getSettingWhatsapp('top-up-deposit')"
                                        @selected="toogleOnOff($event, 'beli_deposit')"
                                        :checked="isSet.beli_deposit"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.beli_deposit)"></div>
                                </div>
                            </template>
                        </ItemSettingWA>
                        <ItemSettingWA jenis-setting="top-up-epayment" :is-show-draft="useTemplate('beli_emoney')">
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen setelah melakukan Top Up Epayment.
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
                                        :checkboxes="getSettingWhatsapp('top-up-epayment')"
                                        @selected="toogleOnOff($event, 'beli_emoney')"
                                        :checked="isSet.beli_emoney"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.beli_emoney)"></div>
                                </div>
                            </template>
                        </ItemSettingWA>
                    </div>

                    <div class="nota-transaksi m-t-16 m-d-16">
                        <div><label class="m-d-0 f-c-midgrey f-16 f-regular">Pengingat</label></div>
                        <ItemSettingWA jenis-setting="notif-selesai" :is-show-draft="useTemplate('selesai')">
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen ketika transaksi selesai & siap diambil.
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
                                        :checkboxes="getSettingWhatsapp('notif-selesai')"
                                        @selected="toogleOnOff($event, 'selesai')"
                                        :checked="isSet.selesai"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.selesai)"></div>
                                </div>
                            </template>
                        </ItemSettingWA>
                        <ItemSettingWA jenis-setting="notif-pengambilan" :is-show-draft="useTemplate('ambil')">
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen sehari setelah transaksi selesai tetapi belum diambil.
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
                                        :checkboxes="getSettingWhatsapp('notif-pengambilan')"
                                        @selected="toogleOnOff($event, 'ambil')"
                                        :checked="isSet.ambil"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.ambil)"></div>
                                </div>
                            </template>
                            <template v-slot:duration>
                                <div class="d-flex-between-center duration-info">
                                    <div style="max-width: 90%;">
                                        <p class="m-d-0 f-14 f-c-midgrey f-regular">Ingatkan setelah</p>
                                        <p class="m-d-0 f-16 f-c-black f-regular">
                                            {{ getDuration }} hari tidak diambil
                                        </p>
                                    </div>

                                    <svg
                                        width="20"
                                        height="19"
                                        viewBox="0 0 20 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        @click="toUpdateDuration"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M16.6663 1.89887C16.4185 1.89887 16.1808 1.99732 16.0056 2.17256L8.25214 9.92602L7.81165 11.688L9.57363 11.2475L17.3271 3.49405C17.5023 3.31881 17.6008 3.08114 17.6008 2.83331C17.6008 2.58548 17.5023 2.3478 17.3271 2.17256C17.1518 1.99732 16.9142 1.89887 16.6663 1.89887ZM14.8271 0.994053C15.3149 0.506252 15.9765 0.232208 16.6663 0.232208C17.3562 0.232208 18.0178 0.506252 18.5056 0.994053C18.9934 1.48185 19.2674 2.14345 19.2674 2.83331C19.2674 3.52316 18.9934 4.18476 18.5056 4.67256L10.5889 12.5892C10.4821 12.696 10.3483 12.7718 10.2018 12.8084L6.86845 13.6418C6.58448 13.7128 6.28407 13.6295 6.07709 13.4226C5.8701 13.2156 5.78689 12.9152 5.85789 12.6312L6.69122 9.29786C6.72785 9.15134 6.80362 9.01752 6.91042 8.91072L14.8271 0.994053ZM1.56524 2.73225C2.03408 2.26341 2.66997 2.00001 3.33301 2.00001H9.16634C9.62658 2.00001 9.99967 2.37311 9.99967 2.83335C9.99967 3.29359 9.62658 3.66668 9.16634 3.66668H3.33301C3.11199 3.66668 2.90003 3.75448 2.74375 3.91076C2.58747 4.06704 2.49967 4.279 2.49967 4.50001V16.1667C2.49967 16.3877 2.58747 16.5997 2.74375 16.7559C2.90003 16.9122 3.11199 17 3.33301 17H14.9997C15.2207 17 15.4326 16.9122 15.5889 16.7559C15.7452 16.5997 15.833 16.3877 15.833 16.1667V10.3333C15.833 9.87311 16.2061 9.50002 16.6663 9.50002C17.1266 9.50002 17.4997 9.87311 17.4997 10.3333V16.1667C17.4997 16.8297 17.2363 17.4656 16.7674 17.9345C16.2986 18.4033 15.6627 18.6667 14.9997 18.6667H3.33301C2.66997 18.6667 2.03408 18.4033 1.56524 17.9345C1.0964 17.4656 0.833008 16.8297 0.833008 16.1667V4.50001C0.833008 3.83697 1.0964 3.20109 1.56524 2.73225Z"
                                            fill="#206CFF"
                                        />
                                    </svg>
                                </div>
                            </template>
                        </ItemSettingWA>
                    </div>
                    <div class="nota-transaksi m-t-16 m-d-16" >
                        <div><label class="m-d-0 f-c-midgrey f-16 f-regular">Pengambilan & Pelunasan</label></div>
                        <ItemSettingWA jenis-setting="bukti-ambil" :is-show-draft="useTemplate('bukti_ambil')">
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen saat melakukan pengambilan
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
                                            :checkboxes="getSettingWhatsapp('bukti-ambil')"
                                            @selected="toogleOnOff($event, 'bukti_ambil')"
                                            :checked="isSet.bukti_ambil"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.bukti_ambil)"></div>
                                </div>
                            </template>
                        </ItemSettingWA>
						<ItemSettingWA jenis-setting="pelunasan" :is-show-draft="useTemplate('pelunasan')">
                            <template v-slot:tooltips>
                                <div>
                                    <label class="m-d-0">
                                        Dikirim ke konsumen saat melakukan pelunasan
                                    </label>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <SOInputOnOff
										:checkboxes="getSettingWhatsapp('pelunasan')"
										@selected="toogleOnOff($event, 'pelunasan')"
										:checked="isSet.pelunasan"
                                    />
                                </div>
                            </template>
                            <template v-slot:draftmsg>
                                <div class="">
                                    <div v-html="getFormatedTemplate(getTemplate.pelunasan)"></div>
                                </div>
                            </template>
                        </ItemSettingWA>
                    </div>
                    <div class="p-x-20 p-y-20 bg-white" style="margin: 0px -20px; border-bottom: 2px solid #EDEDED">
                        <div class="d-flex" style="align-items: center;" @click="back">
                            <div class="m-l-4">
                                <svg
                                    width="16"
                                    height="11"
                                    viewBox="0 0 16 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M15.2559 0.410826C15.5814 0.736263 15.5814 1.2639 15.2559 1.58934L6.08925 10.756C5.93297 10.9123 5.72101 11.0001 5.5 11.0001C5.27899 11.0001 5.06702 10.9123 4.91074 10.756L0.744078 6.58934C0.418641 6.2639 0.418641 5.73626 0.744078 5.41083C1.06951 5.08539 1.59715 5.08539 1.92259 5.41083L5.5 8.98824L14.0774 0.410826C14.4028 0.0853889 14.9305 0.0853888 15.2559 0.410826Z"
                                        fill="#206CFF"
                                    />
                                </svg>
                            </div>
                            <span
                                class="m-l-20 spinner-border spinner-border-sm f-c-midgrey"
                                role="status"
                                aria-hidden="true"
                                style="margin: auto;"
                                v-if="isFetching"
                            ></span>
                            <label v-else class="m-d-0 m-l-20">Selesai</label>
                        </div>
                    </div>
                    <div class="p-x-20 p-y-20 bg-white" style="margin: 0px -20px; border-bottom: 1px solid #EDEDED" v-if="validateAccess('integratedOutlet.delete')">
                        <div class="d-flex" style="align-items: center;" @click="confirmUnlinked">
                            <div class="m-l-4">
                                <IconBased width="20" height="22">
                                    <template v-slot:icons>
                                        <TrashRed />
                                    </template>
                                </IconBased>
                            </div>
                            <span
                                class="m-l-20 spinner-border spinner-border-sm f-c-midgrey"
                                role="status"
                                aria-hidden="true"
                                style="margin: auto;"
                                v-if="isFetching"
                            ></span>
                            <label v-else class="m-d-0 m-l-20">Hapus integrasi outlet ini</label>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff.vue";

import ItemSettingWA from "../../components/ItemSettingWA.vue";
import IconBased from "../../components/iconPack/IconBased.vue";
import TrashRed from "../../components/iconPack/TrashRed2022.vue";
import WhatsappIconMini from "../../components/iconPack/WhatsappIcon1414.vue";
import QuestionMarkCircle from "../../components/iconPack/QuestionMarkCircle1818.vue";

import settingWhatsapp from "../../static/settingWhatsapp";
import defaultDuration from "../../static/defaultDuration";
import { moduleName } from "../../store/state";

export default {
    name: "SetDraftPesan",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        SOLoadingPage,
        SOInputOnOff,
        ItemSettingWA,
        IconBased,
        TrashRed,
        WhatsappIconMini,
        QuestionMarkCircle,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (!vm.getNomorTelp) {
                // vm.back();
            }
        });
    },
    data() {
        return {
            formReady: false,
            bucketUrl: {
                dalbo: "https://storage.googleapis.com/ember-e-dalbo/",
                ages: "https://storage.googleapis.com/",
            },
            imgBucketSrc: "",
            isSet: {
                transaksi: false,
                snap_transaksi_nota: false,
                beli_deposit: false,
                beli_emoney: false,
                selesai: false,
                ambil: false,
                bukti_ambil: false,
				pelunasan: false,
            },
        };
    },
    mounted() {
        this.imgBucketSrc = process.env.NODE_ENV !== "production" ? this.bucketUrl.ages : this.bucketUrl.dalbo;
        this.init();
        this.smartTrackingView('detail_outlet_integrasi_whatsapp')

    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
        formReady: function(newVal, oldVal) {
            if (newVal && !this.getNomorTelp) {
                this.getDetailTinyDevice({ id_mesin: this.settingOutlet.setting.iddevice });
            }
        },
        dataDeviceTiny: function(newDat, oldDat) {
            if (newDat.number) {
                this.setDevice({ type: "iddevice", data: newDat.iddevice });
                this.setDevice({ type: "nama", data: newDat.nama });
                this.setDevice({ type: "nomor", data: newDat.number });
                this.setDevice({ type: "country_code", data: newDat.country_code });
            }
        },
        getSetting: function(newSet, oldSet) {
            this.isSet.transaksi = newSet?.wa_nota ? true : false;
            this.isSet.snap_transaksi_nota = newSet?.wa_nota_snapclean ? true : false;
            this.isSet.beli_deposit = newSet?.wa_nota_topup_deposit ? true : false;
            this.isSet.beli_emoney = newSet?.wa_nota_topup_emoney ? true : false;
            this.isSet.selesai = newSet?.wa_selesai ? true : false;
            this.isSet.ambil = newSet?.wa_ambil ? true : false;
            this.isSet.bukti_ambil = newSet?.wa_bukti_ambil ? true : false;
			this.isSet.pelunasan = newSet?.wa_pelunasan ? true : false;
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            settingOutlet: "settingOutlet",
            dataDeviceTiny: "dataDeviceTiny",
            device: "device",
            response: "response",
            isFetching: "isFetching",
        }),
        getSettingWhatsapp() {
            return function(kode) {
                let set = settingWhatsapp.find((s) => s.id === kode);

                return set?.data || { name: "", data: [] };
            };
        },
        getNomorTelp() {
            return this.device.nomor;
        },
        getCC() {
            return this.device?.country_code || this.dataDeviceTiny.country_code;
        },
        getSetting() {
            return this.settingOutlet.setting;
        },
        getTemplate() {
            return this.settingOutlet.template;
        },
        useTemplate() {
            return (name) => {
                return this.getTemplate[name] ? true : false;
            };
        },
        getDuration() {
            let duration = this.getSetting?.durasi_ambil || defaultDuration;
            return duration.replace(/,/g, " , ");
        },
        getFormatedTemplate() {
            return (text) => {
                return text?.replace(/\*([^\*\~]+)\*/g, "<b>$1</b>");
            };
        },
        getDefaultSwitch() {
            return (idpayload) => {
                switch (idpayload) {
                    case "snap_transaksi_nota":
                        return this.getSetting.wa_nota_snapclean;
                    case "beli_deposit":
                        return this.getSetting.wa_nota_topup_deposit;
                    case "beli_emoney":
                        return this.getSetting.wa_nota_topup_emoney;
                    case "selesai":
                        return this.getSetting.wa_selesai;
                    case "ambil":
                        return this.getSetting.wa_ambil;
                    case "transaksi":
                        return this.getSetting.wa_nota;
                    case "bukti_ambil":
                        return this.getSetting.wa_bukti_ambil;
					case "pelunasan":
                        return this.getSetting.wa_pelunasan;
                }
            };
        },
        getIdOutlet() {
            return this.$route.params.id_outlet;
        },
        getOutlet() {
            return this.getSetting.outlet;
        },
    },
    methods: {
        ...mapActions({
            getSettingWa: `${moduleName}/getSettingWa`,
            resetDataDeviceTiny: `${moduleName}/resetDataDeviceTiny`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            resetListOutlet: `${moduleName}/resetListOutlet`,
            setDevice: `${moduleName}/setDevice`,
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            changeSettingTemplate: `${moduleName}/changeSettingTemplate`,
        }),
        init() {
            this.resetDataDeviceTiny();
            this.getSettingWa({ idoutlet: this.getIdOutlet });
        },
        back() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.daftar_oulet",
            });
            this.resetListOutlet();
        },
        confirmUnlinked() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.confirm_unlinked" });
            this.smartTrackingClick('hapus_outlet_integrasi_whatsapp')
        },
        changeDevice() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.switch_perangkat" });
            this.smartTrackingClick('ubah_outlet_integrasi_whatsapp')
        },
        toUpdateDuration() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.update_duration" });
        },
        setFormReady(val) {
            this.formReady = val;
        },
        toogleOnOff(val, target) {
            let { id_device, id_outlet } = this.$route.params;

            if (val != this.getDefaultSwitch(target)) {
                this.isSet[target] = val;
                let posted = {
                    iddevice: id_device,
                    idpayload: target,
                    idoutlet: id_outlet,
                    status: val ? 1 : 0,
                };

                if (target === "ambil") {
                    posted.durasi = this.getSetting?.durasi_ambil || defaultDuration;
                }

                this.changeSettingTemplate(posted)
                    .then((res) => {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            this.$toast.success(msg);
                            this.init();
                        }
                        this.setFetching(false);
                    })
                    .catch((e) => {
                        this.isSet[target] = !val;
                        this.setFetching(false);
                        this.$toast.error(e);
                    });
            }
        },
    },
};
</script>
<style scoped>
.h-perangkat {
    background-color: #ffffff;
    margin: 0px -20px;
    padding: 8px 20px;
}

.setting-nota {
    background-color: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 34, 119, 0.06);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 8px;
}

.duration-info {
    padding: 8px 12px;
    border: 1px solid #c8d0dd;
    border-radius: 8px;
}
</style>
